import { render } from "./WoundPanelSelectedTests.vue?vue&type=template&id=02fded36"
import script from "./WoundPanelSelectedTests.vue?vue&type=script&lang=js"
export * from "./WoundPanelSelectedTests.vue?vue&type=script&lang=js"

import "./WoundPanelSelectedTests.vue?vue&type=style&index=0&id=02fded36&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sendOuts/testInfo/selectedTestsPreview/WoundPanelSelectedTests.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "02fded36"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('02fded36', __exports__)) {
    console.log('reload')
    api.reload('02fded36', __exports__)
  }
  
  module.hot.accept("./WoundPanelSelectedTests.vue?vue&type=template&id=02fded36", () => {
    console.log('re-render')
    api.rerender('02fded36', render)
  })

}


export default __exports__